/**
 * @author Ariel
 * @desc 帖子查看
 * @date 2020-09-11
 */
import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool, utils_tool} from '@/tool'
import {Descriptions} from "antd";

const {WizContainer, modelUtils, ossFileUtils, WizOssUpload} = framework_tool;
const {WizCard, WizRow, WizCol, WizSpan, WizInput} = component_tool;
const {Session} = utils_tool

const _getValue = (type, key) => {
  const values = {
    sourceType: {
      0: '原创',
      1: '转发',
      2: '分享',
    },
    secrecyType: {
      0: '公开',
      1: '粉丝可见',
      2: '自己可见',
    },
    type: {
      0: '文本',
      1: '图片',
      2: '视频',
    },
  }
  return values[type][key]
}

class InvitationLook extends WizContainer {
  componentName = 'invitationLook'

  constructor(props) {
    super(props)
    const {history} = props
    let detailInfo = {};
    if (history.location && history.location.pathname === '/interact/community/invitation/invitationLook') {
      if (history.location && history.location.record) {
        detailInfo = history.location.record
        Session.set('detailInfo', detailInfo)
      } else {
        detailInfo = Session.get('detailInfo') || {}
      }
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
  }

  getImgList = () => {
    let {imgs} = this.detailInfo
    let imgList = imgs && imgs.split(',') || []
    let urlList = []
    imgList.forEach(img => {
      urlList.push(getOssFilePath(img))
    })
    let r = []
    urlList.forEach(url => {
      let img = url ? <img height={50} width={50} src={url}/> : null
      r.push(
        <WizCol style={{padding: 8}}> {img} </WizCol>
      )
    });
    return <WizRow style={{display: 'flex', marginRight: 0}}>{r}</WizRow>
  }

  _render() {
    const items = this.detailInfo

    return (
      <React.Fragment>
        <WizCard>
          <Descriptions column={1} style={{paddingLeft: 20}} bordered={true}>
            <Descriptions.Item label='帖子来源'>{_getValue('sourceType', items.sourceType)}</Descriptions.Item>
            <Descriptions.Item label='帖子类型'>{_getValue('type', items.type)}</Descriptions.Item>
            <Descriptions.Item label='帖子内容'>
              <WizInput.TextArea
                value={items.content}
                readonly={true}
                autoSize={true}
              />
            </Descriptions.Item>
            <Descriptions.Item label='图片'>{this.getImgList(items.imgs)}</Descriptions.Item>
            <Descriptions.Item label='视频'>{items.video}</Descriptions.Item>
            <Descriptions.Item label='所属话题'>{items.topicName}</Descriptions.Item>
            <Descriptions.Item label='账号'>{items.userName}</Descriptions.Item>
            <Descriptions.Item label='姓名'>{items.fullName}</Descriptions.Item>
            <Descriptions.Item label='昵称'>{items.nickName}</Descriptions.Item>
            <Descriptions.Item label='隐私设置'>{_getValue('secrecyType', items.secrecyType)}</Descriptions.Item>
            <Descriptions.Item label='发帖时间'>{items.createTime}</Descriptions.Item>
          </Descriptions>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const load = modelUtils.getLoadingState(state, 'invitation')
  return {
    ...load
  }
};

export default connect(mapStateToProps)(InvitationLook)
